import { api } from '../../../../helpers/api/api';
import {
  login as loginApi,
  signup as signupApi,
  forgotPassword as forgotPasswordApi,
  resetPassword as resetPasswordApi,
} from '../../../../helpers/api/auth-api.service';
import { decodeJwtToken, setAuthHeader } from '../../../../helpers/api/auth.service';
import { Authorization } from '../../types/auth.types';

export const authService = {
  login: async (credentials: { username: string; password: string }) => {
    const client_id = 'sensware_spa';
    const grant_type = 'password';

    const { data, error } = await loginApi({ ...credentials, client_id, grant_type });

    if (error || !data) {
      console.error('Login failed:', error);
      throw new Error(error || 'Login failed');
    }

    const { access_token, refresh_token, token_type, expires_in } = data.data as Authorization;
    const { user, authorization } = decodeJwtToken({
      access_token,
      refresh_token,
      token_type,
      expires_in,
    });

    api.setLoggedInUser(user, authorization);
    setAuthHeader(authorization.access_token);
    return user;
  },

  logout: () => {
    api.setLoggedInUser(null);
    setAuthHeader(null);
  },

  signup: async (userData: { fullname: string; email: string; password: string }) => {
    const { data, error } = await signupApi(userData);

    if (error || !data) {
      console.error('Signup failed:', error);
      throw new Error(error || 'Signup failed');
    }

    return data;
  },

  forgotPassword: async (email: string) => {
    const { data, error } = await forgotPasswordApi({ email });

    if (error || !data) {
      console.error('Forgot Password failed:', error);
      throw new Error(error || 'Failed to send password reset email');
    }

    return data;
  },

  resetPassword: async (resetData: { newPassword: string; token: string; id: string }) => {
    const { data, error } = await resetPasswordApi(resetData);

    if (error || !data) {
      console.error('Reset Password failed:', error);
      throw new Error(error || 'Failed to reset password');
    }

    return data;
  },
};
